import { useEffect, useState } from "react";
import { db } from "~/db/db";
import { getParametroReflex } from "~services/SincronizacaoServices";

const useParametroReflex = () => {
  const [parametroReflex, setParametroReflex] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchParametro = async () => {
      try {
        const registros = await db.parametroReflex.toArray();
        setParametroReflex(registros ?? []);

        if ((!registros || registros.length === 0)) {
          try {
            const res = await getParametroReflex(1000, 0, null);
            const remoteData = res?.data?.data ?? res?.data ?? null;
            if (Array.isArray(remoteData) && remoteData.length > 0) {
              try {
                await db.parametroReflex.bulkPut(remoteData);
                setParametroReflex(remoteData);
              } catch (e) {
                console.error('Erro ao salvar parametroReflex remoto no DB:', e);
              }
            }
          } catch (e) {
            console.error('Erro ao buscar parametroReflex remoto:', e);
          }
        }
      } catch (error) {
        console.error("Erro ao buscar parametroReflex:", error);
        setParametroReflex([]);
      } finally {
        setLoading(false);
      }
    };

    fetchParametro();
  }, []);

  return { parametroReflex, loading };
};

export default useParametroReflex;
